import { render } from "./DesignRequestForm.vue?vue&type=template&id=7fe438fe&scoped=true"
import script from "./DesignRequestForm.vue?vue&type=script&lang=js"
export * from "./DesignRequestForm.vue?vue&type=script&lang=js"

import "./DesignRequestForm.vue?vue&type=style&index=0&id=7fe438fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fe438fe"]])

export default __exports__